<template>
  <div
    class="recordings flex justify-between items-center mb-4 w-full py-2 px-6"
    @click="selectThisRecording"
  >
    <div class="flex-col w-full">
      <div class="w-full flex justify-between items-center">
        <div class="flex">
          <p class="text-lg font-semibold">
            {{ truncateText(recording.url.Name, 20) }}
          </p>
          <!-- <p>{{ recording.url.Name }} </p> -->
        </div>
        <div class="flex items-center">
          <!-- <vs-button class="custm-style" @click="editRecord">
                        <vx-tooltip text="/Editor" position="top">
                            <svg width="32" height="32" viewBox="0 0 18 14" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M17 1H16V2H15V3H14V4H13V5H12V6H11V7H10V6H9V5H8V4H7V3H6V4H5V5H4V6H3V7H2V8H1V11H2V12H1V13H17V6H16V5H17V1ZM15 6H16V7H15V6ZM14 6V5H15V6H14ZM14 6H12V7H14V6ZM3 10V11H2V10H3ZM4 9V10H3V9H4ZM5 9H4V8H5V9ZM6 10H5V9H6V10ZM7 10V11H6V10H7ZM8 9V10H7V9H8ZM9 8V9H8V8H9ZM9 8H10V7H9V8Z"
                                    fill="black" />
                                <path d="M15 1H16V2H15V1Z" fill="white" />
                                <path d="M14 3H15V2H14V3Z" fill="white" />
                                <path d="M13 4H14V3H13V4Z" fill="white" />
                                <path d="M12 5H13V4H12V5Z" fill="white" />
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M12 6V5H11V6H10V5H9V4H8V3H7V2H6V3H5V4H4V5H3V6H2V7H1V8H0V13H1V14H17V13H18V1H17V0H16V1H17V5H16V6H15V5H14V6H12ZM12 6V7H14V6H15V7H16V6H17V13H1V12H2V11H3V10H4V9H5V10H6V11H7V10H8V9H9V8H10V7H11V6H12ZM10 7H9V8H8V9H7V10H6V9H5V8H4V9H3V10H2V11H1V8H2V7H3V6H4V5H5V4H6V3H7V4H8V5H9V6H10V7Z"
                                    fill="white" />
                            </svg>
                        </vx-tooltip>
                    </vs-button> -->
          <!-- isMp4Ready -->
          <vs-button
            v-if="isMp4Ready"
            class="custm-style"
            @click="downloadRecording"
          >
            <vx-tooltip text="/download" position="top">
              <Download />
            </vx-tooltip>
          </vs-button>
          <vs-button v-else-if="isMp4Processing" class="custm-style">
            <vx-tooltip text="fetching mp4..." position="top">
              <Processing />
            </vx-tooltip>
          </vs-button>
          <vs-button v-else class="custm-style" @click="fetchVideoUrlWithRetry">
            <vx-tooltip text="retry" position="top">
              <Retry />
            </vx-tooltip>
          </vs-button>
          <!-- <vs-button class="custm-style" @click="openVideoRecording">
                        <vx-tooltip text="/transcription" position="top">
                            <img class="w-12 h-10 object-contain" src="@/assets/images/ai.png" />
                        </vx-tooltip>
                    </vs-button> -->
          <vs-button class="custm-style" @click="openVideoRecording">
            <vx-tooltip text="/playback" position="top">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 0H31V31H0V0Z" fill="#D7DF23" />
                <path
                  d="M31 31V31.8596H31.8596V31H31ZM30.1404 0V31H31.8596V0H30.1404ZM31 30.1404H0V31.8596H31V30.1404Z"
                  fill="white"
                />
                <path
                  d="M7.62409 7.88238H6.10059V23.1174H7.62409V7.88238Z"
                  fill="black"
                />
                <path
                  d="M7.62413 6.35889L7.62409 7.88238L10.6711 7.88239V6.35889H7.62413Z"
                  fill="black"
                />
                <path
                  d="M10.6711 7.88239L10.6711 9.4059L13.7181 9.40589L13.7181 7.8824L10.6711 7.88239Z"
                  fill="black"
                />
                <path
                  d="M13.7181 9.40589V10.9294L16.7652 10.9294L16.7651 9.40589H13.7181Z"
                  fill="black"
                />
                <path
                  d="M16.7652 10.9294V12.4529L19.8121 12.4529L19.8121 10.9294H16.7652Z"
                  fill="black"
                />
                <path
                  d="M19.8121 12.4529V13.9764L22.8592 13.9764L22.8592 12.4529H19.8121Z"
                  fill="black"
                />
                <path
                  d="M22.8592 17.0234H24.3827V13.9764H22.8592V17.0234Z"
                  fill="black"
                />
                <path
                  d="M19.8121 17.0234V18.5469H22.8592L22.8592 17.0234L19.8121 17.0234Z"
                  fill="black"
                />
                <path
                  d="M16.7652 18.5469V20.0704H19.8121L19.8121 18.5469L16.7652 18.5469Z"
                  fill="black"
                />
                <path
                  d="M13.7181 20.0704V21.5939H16.7651L16.7652 20.0704L13.7181 20.0704Z"
                  fill="black"
                />
                <path
                  d="M10.6711 21.5939L10.6711 23.1174L13.7181 23.1174L13.7181 21.5939L10.6711 21.5939Z"
                  fill="black"
                />
                <path
                  d="M7.62409 23.1174L7.62413 24.6409H10.6711V23.1174L7.62409 23.1174Z"
                  fill="black"
                />
                <path
                  d="M10.671 7.88232H7.62402V23.1174H10.671V21.5939H13.718V20.0704H16.765V18.5469H19.8121V17.0233H22.8591V13.9763H19.8121V12.4528H16.765V10.9293H13.718V9.40583H10.671V7.88232Z"
                  fill="white"
                />
              </svg>
            </vx-tooltip>
          </vs-button>
          <SimpleMenu :menuList="recordingCardMenuItems">
            <template #menuButton>
              <vs-button class="custm-more-icon">
                <img src="@/assets/images/menu.svg" />
              </vs-button>
            </template>
          </SimpleMenu>
        </div>
      </div>
      <div class="w-full flex justify-between items-center">
        <p class="font-small pb-2">
          >>Room name :
          <span class="font-semibold text-primary">{{
            recording.room_name
          }}</span>
        </p>
        <p class="text-primary">
          <span v-if="sizeLabel" class="rec-size">{{ sizeLabel }} · </span>
          {{ recording.url['Start Time (Readable)'].split(' ')[0] }}
        </p>
      </div>
    </div>
    <RenameModal
      v-if="activeModal === 'renameRecording'"
      :closeModal="() => (activeModal = '')"
      :recording="recording"
      :getRecordings="getRecordings"
    />
    <DeleteModal
      v-if="activeModal === 'deleteRecording'"
      :closeModal="() => (activeModal = '')"
      :recording="recording"
      :getRecordings="getRecordings"
    />
  </div>
</template>

<script>
import SimpleMenu from '@/components/common/simpleMenu/SimpleMenu.vue';
import MoreIcon from '@/assets/svgs/button-icons/more.vue';
import RenameModal from './recording-options/RenameModal.vue';
import DeleteModal from './recording-options/DeleteModal.vue';
import Processing from '@/assets/svgs/menu-icons/processing.vue';
import Download from '@/assets/svgs/menu-icons/download.vue';
import Retry from '@/assets/svgs/menu-icons/retry.vue';
import Copymp4 from '@/assets/svgs/menu-icons/copymp4.vue';

export default {
  name: 'RecordingCard',
  props: ['recording', 'index', 'getRecordings'],
  components: {
    SimpleMenu,
    MoreIcon,
    RenameModal,
    DeleteModal,
    Processing,
    Download,
    Retry,
    Copymp4,
  },
  computed: {
    // what this recording costs the account's storage
    sizeLabel() {
      const url = this.recording && this.recording.url;
      const pb = url && url['Playback Data'];
      return (pb && pb['Playback Size']) || '';
    },
  },
  data() {
    return {
      activeModal: '',
      isMp4Processing: false,
      isMp4Ready: false,
      recordingCardMenuItems: [
        // {
        //     label: "Play",
        //     icon: () => import("@/assets/svgs/button-icons/copy.vue"),
        //     onClick: () => this.openRecording()
        // },
        {
          label: 'Edit',
          icon: () => import('@/assets/svgs/menu-icons/edit.vue'),
          onClick: () => this.openEditor(),
        },
        {
          label: 'Auto Rename',
          icon: () => import('@/assets/svgs/menu-icons/auto-rename.vue'),
          onClick: () => this.$emit('auto-rename', this.recording),
        },
        {
          label: 'Manual Rename',
          icon: () => import('@/assets/svgs/menu-icons/pen.vue'),
          onClick: () => (this.activeModal = 'renameRecording'),
        },
        {
          label: 'Video link',
          icon: () => import('@/assets/svgs/menu-icons/copymp4.vue'),
          onClick: () => this.copyRecording(),
        },
        {
          label: 'Delete',
          icon: () => import('@/assets/svgs/menu-icons/bin.vue'),
          onClick: () => (this.activeModal = 'deleteRecording'),
          isDanger: true,
        },
        // {
        //     label: "Editor",
        //     icon: () => import("@/assets/svgs/menu-icons/editor.vue"),
        //     onClick: () => this.editRecord(),
        //     tooltip: "The recording may require some time for processing. If it doesn't work, please try again later.",
        //     tooltipPosition: "left",
        //     isDanger: true,
        // },
      ],
    };
  },
  mounted() {
    this.fetchVideoUrlWithRetry();
  },
  methods: {
    fetchVideoUrlWithRetry() {
      const interval = 4000; // 4 seconds
      const maxDuration = 0.5 * 60 * 1000; // 0.5 minutes in milliseconds
      const startTime = Date.now();
      const videoUrl =
        this.recording.url['Playback Data']['Playback URL'].replace(
          '/presentation/2.3',
          '/video'
        ) + '/video-0.m4v';

      this.isMp4Processing = true;

      const intervalId = setInterval(async () => {
        try {
          const video = document.createElement('video');

          video.onloadeddata = () => {
            console.log('Video file exists.');
            clearInterval(intervalId);
            this.isMp4Processing = false;
            this.isMp4Ready = true;
          };

          video.onerror = () => {
            console.log('Video not found (404 or network error).');
          };
          video.src = videoUrl;
          // const response = await fetch(videoUrl);

          // if (response.status === 200) {
          //     console.log('Video URL is ready:', videoUrl);
          //     clearInterval(intervalId);
          //     this.isMp4Processing = false;
          //     this.isMp4Ready = true;
          //     return;
          // }

          // console.log(`Received status ${response.status}. Retrying...`);
        } catch (error) {
          console.error('Fetch error:', error);
        }

        // Stop retrying if 5 minutes have passed
        if (Date.now() - startTime > maxDuration) {
          console.log('Max duration reached. Stopping retries.');
          clearInterval(intervalId);
          this.isMp4Processing = false;
          this.isMp4Ready = false;
          this.$vs.notify({
            title: 'Retry later!',
            text: 'recording is under processing, please try again later',
            color: 'danger',
          });
        }
      }, interval);
    },

    openEditor() {
      const meetingId = this.recording.url['Record ID'];
      setTimeout(() => {
        const url = `https://beta.editor.video.wiki/studio?meetingId=${meetingId}`;
        window.open(url, '_blank');
      }, 2000);
    },
    selectThisRecording() {
      if (this.recording && this.recording.url['Record ID']) {
        this.$emit('recording-selected', this.recording);
      }
    },
    downloadRecording() {
      const url =
        this.recording.url['Playback Data']['Playback URL'].replace(
          '/presentation/2.3',
          '/video'
        ) + '/video-0.m4v';
      window.open(url, '_blank');
      // fetch(url)
      //     .then(response => {
      //         if (!response.ok) {
      //             throw new Error(`HTTP error! status: ${response.status}`);
      //         }
      //         return response.blob();
      //     })
      //     .then(blob => {
      //         const downloadUrl = URL.createObjectURL(blob);
      //         const a = document.createElement('a');
      //         a.href = downloadUrl;
      //         // a.download = fileName;
      //         document.body.appendChild(a);
      //         a.click();
      //         a.remove();
      //         URL.revokeObjectURL(downloadUrl); // Cleanup the URL object
      //     })
      //     .catch(error => {
      //         console.error('Failed to save the MP4 file:', error);
      //     });
    },
    openRecording() {
      // for mp4 link
      // const playbackURL =
      //     this.recording.url['Playback Data']['Playback URL'].replace(
      //         '/presentation/2.3',
      //         '/video'
      //     ) + '/video-0.m4v';
      const playbackURL = this.recording.url['Playback Data']['Playback URL'];
      window.open(playbackURL, '_blank');
    },
    openVideoRecording() {
      const mp4URL =
        this.recording.url['Playback Data']['Playback URL'].replace(
          '/presentation/2.3',
          '/video'
        ) + '/video-0.m4v';

      // Save data in Vuex
      const recordingId = this.recording.url['Record ID'];
      this.$store.dispatch('cast/saveRecording', {
        recording: this.recording.url,
        videoUrl: mp4URL,
      });
      const routeData = this.$router.resolve({
        name: 'RecordingPlay',
        params: { recordingId },
      });
      window.open(routeData.href, '_blank');
      // Navigate to RecordingPlay without passing params
      // this.$router.push({ name: "RecordingPlay", params: { recordingId } });
    },
    copyRecording() {
      navigator.clipboard.writeText(
        this.recording.url['Playback Data']['Playback URL'].replace(
          '/presentation/2.3',
          '/video'
        ) + '/video-0.m4v'
      );
    },
    editRecord() {
      const meetingId = this.recording.url['Record ID'];
      setTimeout(() => {
        const url = `https://beta.editor.video.wiki/studio?meetingId=${meetingId}`;
        window.open(url, '_blank');
      }, 2000);
    },

    truncateText(text, maxLength) {
      if (text.length > maxLength) {
        return text.slice(0, maxLength) + '...';
      } else {
        return text;
      }
    },
  },
};
</script>

<style scoped>
.rec-size {
  color: #8a8a8a;
}

* {
  font-family: 'JetBrains Mono', monospace !important;
}

.custm-more-icon {
  background-color: transparent !important;
  border: none !important;
}

.recordings {
  border-top: 1px solid white;
  border-left: 1px solid white;
  border-right: 2px solid white;
  border-bottom: 2px solid white;
  box-shadow: 3px 3px 0px 0px white;
}

.recordings:hover {
  border-top: 1px solid #d7df23;
  border-left: 1px solid #d7df23;
  border-right: 2px solid #d7df23;
  border-bottom: 2px solid #d7df23;
  box-shadow: 3px 3px 0px 0px #d7df23;
}

.custm-style {
  background: none !important;
  outline: none !important;
  border: none !important;
  background-color: transparent !important;
}

.custm-style:hover {
  box-shadow: none !important;
}
</style>
